import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import StudioSidebar from '../../components/ui/StudioSidebar';
import RevenueCards from './components/RevenueCards';
import RevenueCharts from './components/RevenueCharts';
import GamePerformanceTable from './components/GamePerformanceTable';
import PayoutHistory from './components/PayoutHistory';
import PerformanceInsights from './components/PerformanceInsights';
import ExportModal from './components/ExportModal';

const StudioRevenueAnalytics = () => {
  const [selectedDateRange, setSelectedDateRange] = useState('30d');
  const [showExportModal, setShowExportModal] = useState(false);

  return (
    <>
      <Helmet>
        <title>Studio Revenue Analytics - Solis Games</title>
        <meta name="description" content="Comprehensive revenue analytics and performance insights for game developers" />
      </Helmet>

      <div className="flex h-screen bg-background">
        <StudioSidebar />

        {/* Main Content */}
        <div className="flex-1 lg:ml-64">
          {/* Header */}
          <div className="bg-card/95 backdrop-blur-sm border-b border-border p-6 lg:p-8">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
              <div>
                <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-2">
                  <span>Studio Portal</span>
                  <span>/</span>
                  <span className="text-foreground">Analytics</span>
                </nav>
                <h1 className="text-3xl font-bold text-foreground">Revenue Analytics</h1>
                <p className="text-muted-foreground">Comprehensive insights into your game earnings and performance</p>
              </div>

              <div className="flex items-center space-x-3">
                <select 
                  value={selectedDateRange}
                  onChange={(e) => setSelectedDateRange(e.target.value)}
                  className="px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                >
                  <option value="7d">Last 7 days</option>
                  <option value="30d">Last 30 days</option>
                  <option value="90d">Last 90 days</option>
                  <option value="1y">Last year</option>
                </select>
                <button 
                  onClick={() => setShowExportModal(true)}
                  className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors text-sm font-medium"
                >
                  Export Report
                </button>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="p-6 lg:p-8 space-y-8 pb-24 lg:pb-8">
            <RevenueCards dateRange={selectedDateRange} />
            <RevenueCharts dateRange={selectedDateRange} />
            <GamePerformanceTable />
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
              <PayoutHistory />
              <PerformanceInsights />
            </div>
          </div>
        </div>

        {showExportModal && (
          <ExportModal 
            onClose={() => setShowExportModal(false)}
            dateRange={selectedDateRange}
          />
        )}
      </div>
    </>
  );
};

export default StudioRevenueAnalytics;
